/**
 * Nurture Buy Box
 * - Intercepts ATC button, adds to cart via fetch, then navigates to /cart
 */
(function () {
  function init() {
    var form = document.querySelector('[data-type="add-to-cart-form"]');
    if (!form) return;

    var btn = form.querySelector('[name="add"]');
    if (!btn) return;

    var errorWrapper = form.querySelector('.product-form__error-message-wrapper');
    var errorMessage = errorWrapper && errorWrapper.querySelector('.product-form__error-message');

    function showError(message) {
      if (!errorWrapper || !errorMessage) {
        window.alert(message);
        return;
      }
      errorMessage.textContent = message;
      errorWrapper.hidden = false;
    }

    function hideError() {
      if (errorWrapper) errorWrapper.hidden = true;
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      hideError();

      // Visual feedback
      btn.disabled = true;
      var originalText = btn.innerHTML;
      btn.innerHTML = btn.getAttribute('data-loading-text') || 'Adding…';

      var formData = new FormData(form);

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          btn.innerHTML = originalText;
          btn.disabled = false;
          if (data.status) {
            // Shopify returned an error (e.g. sold out)
            showError(data.description || data.message || 'This item could not be added to your cart.');
            console.warn('Cart error:', data.description);
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function () {
          btn.innerHTML = originalText;
          btn.disabled = false;
          showError('Something went wrong adding this item to your cart. Please try again.');
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
